import { useCallback, useEffect, useMemo, useState } from 'react';
import { fetchTemplateDetail } from '../../api/templatesApi';
import { fromTemplateGraph, computeLevels } from './taskGraph';
import { inputsFromTemplate } from './runInputs';

export function useTask(id) {
  const [state, setState] = useState({ loading: true, error: false, template: null });
  const [tick, setTick] = useState(0);

  useEffect(() => {
    // Per-effect flag: a fetch for an earlier id (or load) never writes.
    let cancelled = false;
    setState({ loading: true, error: false, template: null });
    fetchTemplateDetail(id).then(
      (template) => { if (!cancelled) setState({ loading: false, error: false, template }); },
      () => { if (!cancelled) setState({ loading: false, error: true, template: null }); },
    );
    return () => { cancelled = true; };
  }, [id, tick]);

  const reload = useCallback(() => setTick((t) => t + 1), []);

  const { template } = state;
  const derived = useMemo(() => {
    const graph = fromTemplateGraph(template?.graph_structure);
    return { graph, levels: computeLevels(graph), inputs: inputsFromTemplate(template) };
  }, [template]);

  return { loading: state.loading, error: state.error, template, ...derived, reload };
}
